module.exports = "<router-outlet>\r\n    <div *ngIf=\"objLoaderStatus\" class=\"page-splash\">\r\n        <div class=\"spinner-background-c page-splash-message-image\">\r\n            <img src=\"assets/images/bx_loader.gif\" />\r\n        </div>\r\n    </div>\r\n</router-outlet>"


//////////////////
// WEBPACK FOOTER
// D:/Projects/Web/Dubai/DubaisaleV1/cpapi.v1/CPDubaisaleApp/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main